import { createSlice } from '@reduxjs/toolkit';
import { resetToInitialState } from '~/reducers/common-actions';

export const bookingMetricsSlice = createSlice({
    name: 'bookingMetrics',
    initialState: {},
    reducers: {
        setBookingMetrics: (state, action) => {
            return action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetToInitialState, () => {
            return {};
        });
    }
});

export const { setBookingMetrics } = bookingMetricsSlice.actions;

export const selectBookingMetrics = (state) => state.bookingMetrics;

export default bookingMetricsSlice.reducer;
